/**
 * Copyright © 2025 Farmlands Co-operative Society Limited. All rights reserved.
 *
 * This document contains confidential information and is the property of Farmlands.
 * Unauthorised reproduction or distribution of any part of this publication is prohibited without written consent.
 */

import { Box, Button, Stack, Typography } from '@mui/material';
import React from 'react';
import { useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import { BackButton } from '../components/BackButton';
import { PageContainer } from '../components/layout/PageContainer';
import YesNoAction from '../components/YesNoAction';
import { selectUserContactDetails } from '../features/azure-b2c/storage';
import { TestIds } from '../testIds';
import { Quote } from '../features/quotes/storage/types';
import { PRODUCTS_ROUTE } from '../features/products/products.routes';

export const RequestAQuoteSuccess = () => {
  const userDetails = useSelector(selectUserContactDetails);
  const navigate = useNavigate();

  const location = useLocation();

  // Access the quote object from state
  const { quote } = (location.state as { quote: Quote }) || {};

  return (
    <PageContainer data-testid={TestIds.pages.requestAQuoteSuccess}>
      <BackButton text='Products' onClick={() => navigate(PRODUCTS_ROUTE)} />
      <YesNoAction
        display='Quote request sent'
        subheading={
          <Typography variant='h4' sx={{ mt: 4, mb: 2 }}>
            Thanks {userDetails?.firstName}! Your quote request is sent to your account manager.
          </Typography>
        }
        body={
          <Stack gap={2}>
            <Box>
              <Button
                variant='contained'
                onClick={() => {
                  navigate(`/quotes/${quote.id}`, {
                    state: {
                      quote: quote,
                    },
                  });
                }}
              >
                View Quote
              </Button>
            </Box>
          </Stack>
        }
      />
    </PageContainer>
  );
};
